__turbopack_context__.v({
  "iframe": "walkthrough-media-module-scss-module__AgzIJa__iframe",
  "play-button": "walkthrough-media-module-scss-module__AgzIJa__play-button",
  "poster": "walkthrough-media-module-scss-module__AgzIJa__poster",
});
